export default __webpack_public_path__ + "static/overpass-regular-a8ba9ff7b7d056f355e0e9439faa2b7e.woff";